<div class="page-layout blank p-0" fusePerfectScrollbar>

    <iframe 
        src="/ypm/ypmhours?randomString=1"
        width="100%" height="100%" 
        allowtransparency="true" 
        style="border:none;background:  #C5C6CB;"></iframe>

</div>
